module.exports = __webpack_public_path__ + "img/my-notice-icon.9e531b6b.png";